<template>
  <vg-card>
    <vg-form>
      <vg-field
          v-for="item in subjectList"
          :key="item.id.value"
          :label="item.billingAccountName"
          is-link
          @click="choiceProject(item)"
      />
    </vg-form>
  </vg-card>
</template>
<script>

import {mapState} from "pinia";
// import useformStore from "@/store/form";
// import eventBus from '@/router/eventBus';
import useformStore from "@/store/sporadicChargeform";
import VgCard from "@/components/Commons/VgCard.vue";
import VgForm from "@/components/Commons/VgForm.vue";
import VgField from "@/components/Commons/VgField.vue";
import chargeProjectStore from "@/store/chargeProject";

export default {
    name: "choiceSubject",
    components: {
      VgField,
      VgForm,
      VgCard
    },
    props: {

    },
    data() {
        return {
            subjectList:[],
        };
    },
    created() {
        this.getSubProjectList();
    },
    computed: {
        ...mapState(useformStore, ['form']),
        ...mapState(chargeProjectStore, ['chargeProject']),
    },
    methods: {
      getSubProjectList() {
        const chargeProjectList = chargeProjectStore();
        console.log("ssssss");
        console.log(chargeProjectList.getChangePro)
        this.subjectList = chargeProjectList.getStrProjectList;
      },
        choiceProject(item){
            console.log("计费科目");
            console.log(item);
            const formStore = useformStore();
            //formStore.strSubject = item;
            console.log(formStore?.form?.strProject);
            formStore.setForm(
                {
                strProject: formStore?.form?.strProject,
                strSubject: item,
                strSubSubject: formStore?.form?.strSubSubject,
                strPrice: formStore?.form?.strPrice,
                strRemarks: formStore?.form?.strRemarks,
                paymentUpperLimit : formStore?.form?.paymentUpperLimit,
                }
            );
            console.log("22222")
            console.log(formStore);
            this.$router.go(-1);
        },
    },
};
</script>
<style scoped>
.choice-list{
    width: 353px;
    border: 1px solid #E7E5E7;
    border-radius: 10px;
    margin: 10px;
}
.title {
    padding: 10px;
}

.choice-project-button {
    width: 70px;
    height: 36px;
    float: right;
    margin-top: -40px;
    margin-right: 40px;
}

.choice-project-search>>>.van-icon-search:before {
    content: '';
}

.choice-project-search {
    width: 275px;
    height: 44px;
    /* float: left; */
}
.choice-project-search >>> .van-search__content {
    border: 1px solid #E7E5E7;
    background-color: white;
}
</style>
